import {Alert, Select, Typography} from 'antd';
import type {AzdoBranch} from '../../api/azdo-lookup';

function orderBranchesForSelect(branches: AzdoBranch[]): AzdoBranch[] {
    const pinned = branches.find((b) => b.isDefault) ?? branches.find((b) => b.name === 'main');
    if (!pinned) return branches;
    const rest = branches.filter((b) => b.name !== pinned.name);
    return [pinned, ...rest];
}

interface Props {
    repositorySelected: boolean;
    branches: AzdoBranch[];
    loading: boolean;
    error: string | null;
    selectedBranch: string | null;
    onSelect: (name: string) => void;
    disabled?: boolean;
}

export const BranchStep = ({
    repositorySelected,
    branches,
    loading,
    error,
    selectedBranch,
    onSelect,
    disabled,
}: Props) => (
    <section>
        <Typography.Title level={5}>3. Target branch</Typography.Title>
        {!repositorySelected ? (
            <Select
                showSearch={false}
                style={{width: '100%'}}
                placeholder='Select a repository first'
                disabled
                options={[]}
            />
        ) : error ? (
            <Alert type='error' title='Failed to load branches' description={error}/>
        ) : (
            <Select
                showSearch={true}
                optionFilterProp='label'
                style={{width: '100%'}}
                placeholder='Select a branch'
                loading={loading}
                value={selectedBranch ?? undefined}
                onChange={onSelect}
                disabled={disabled || loading}
                options={orderBranchesForSelect(branches).map((b) => ({
                    value: b.name,
                    label: b.isDefault ? `${b.name} (default)` : b.name,
                }))}
            />
        )}
    </section>
);
